export const IMAGES = {
  truck:
    "https://images.unsplash.com/photo-1578857371787-189d8b9eda84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxzZW1pJTIwdHJ1Y2slMjBuaWdodCUyMGhpZ2h3YXklMjBtb3Rpb24lMjBibHVyfGVufDB8fHx8MTc5MTM2MTg4OHww&ixlib=rb-4.1.0&q=85",
  plane:
    "https://images.unsplash.com/photo-1615317779547-2078d82c549a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxjYXJnbyUyMHBsYW5lJTIwaW4lMjBza3l8ZW58MHx8fHwxNzkxMzYxODg4fDA&ixlib=rb-4.1.0&q=85",
  van:
    "https://images.unsplash.com/photo-1688619102322-cee55c13f89e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxzcHJpbnRlciUyMHZhbiUyMGRyaXZpbmd8ZW58MHx8fHwxNzkxMzYxODg4fDA&ixlib=rb-4.1.0&q=85",
  warehouse:
    "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHx3YXJlaG91c2UlMjBwYWxsZXRzJTIwd2FyZWhvdXNlfGVufDB8fHx8MTc5MTM2MTg4OHww&ixlib=rb-4.1.0&q=85",
  serverroom:
    "https://images.unsplash.com/photo-1785682231847-93265d8e633d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxkYXJrJTIwc2VydmVyJTIwcm9vbSUyMGNlbnRlcnxlbnwwfHx8fDE3OTEzNjk5OTh8MA&ixlib=rb-4.1.0&q=85",
  same_day_air:
    "https://images.unsplash.com/photo-1713182568612-58dd29b515b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxhaXIlMjBjYXJnbyUyMGxvYWRpbmclMjBuaWdodHxlbnwwfHx8fDE3OTEzNzAzNTV8MA&ixlib=rb-4.1.0&q=85",
};

export const PHONE_DISPLAY = "(800) 654-9403";
export const PHONE_NUMBER = "(800) 654-9403";
export const PHONE_TEL = "tel:8006549403";
export const EMAIL = "jason@myway2gotransport.com";

export const services = [
  {
    slug: "hot-shot-trucking",
    name: "Hot Shot Trucking",
    tag: "GROUND / POINT-TO-POINT",
    image: IMAGES.truck,
    blurb:
      "Urgent B2B freight moved direct, door to door, on dedicated trucks and vans — often picked up within two hours of your call.",
    description: [
      "Hot shot trucking is the fastest ground answer for urgent, time-sensitive freight. When a production line is down, a jobsite is waiting, or a customer deadline is hours away, Way2Go dispatches a dedicated vehicle direct to your pickup — no terminals, no transfers, no waiting on someone else's schedule.",
      "Every hot shot run is point-to-point with a single driver and a single vehicle, tracked from pickup to proof of delivery. Construction, oil and gas, agriculture, manufacturing — if downtime costs you money, this is the service built for you.",
    ],
    features: [
      "Typical pickup within 2 hours, nationwide",
      "Dedicated vehicle — your freight only",
      "Direct point-to-point, no terminals or transfers",
      "Real human updates from pickup to POD",
      "Cargo vans, sprinters, straight trucks and flatbeds",
    ],
    stats: [
      { k: "2 HR", v: "typical pickup" },
      { k: "24/7", v: "live dispatch" },
      { k: "48", v: "states covered" },
    ],
  },
  {
    slug: "expedited-freight",
    name: "Expedited Freight",
    tag: "GROUND / DEDICATED",
    image: IMAGES.van,
    contain: true,
    blurb:
      "Dedicated sprinter vans and straight trucks that drive all day and night — the fastest ground solution for pallets and critical loads.",
    description: [
      "For a few pallets or a full dedicated load, expedited ground keeps your freight moving around the clock. Our sprinter vans and straight trucks drive all day and night, shaving hours — often days — versus conventional shipping, with tracking throughout.",
      "On-demand or scheduled, immediate pickup or planned in advance: you control the timing and the cost. Up to 3,000 lbs in a sprinter, up to 10,000 lbs in a straight truck, and 53' dry vans or flatbeds for full truckload urgency.",
    ],
    features: [
      "Sprinter vans up to 3,500 lbs, straight trucks to 10,000 lbs",
      "Teams available for non-stop long-haul",
      "Immediate or scheduled on-demand pickup",
      "Fully tracked with milestone updates",
      "The fastest legal ground transit available",
    ],
    stats: [
      { k: "3,000", v: "mi range, non-stop" },
      { k: "48 MPH", v: "planning average" },
      { k: "365", v: "days a year" },
    ],
  },
  {
    slug: "domestic-air-freight",
    name: "Domestic Air Freight",
    tag: "AIR / OVERNIGHT",
    image: IMAGES.plane,
    blurb:
      "Overnight air cargo nationwide for heavier freight over long distances — door-to-door with negotiated rates.",
    description: [
      "When ground can't make the distance, domestic air cargo can. Way2Go moves heavier overnight freight anywhere in the USA with door-to-door service — pickup, tender, recovery and final delivery handled as one seamless move.",
      "Our reduced, negotiated air rates mean your toughest long-distance deadlines can be reached within budget. Monday–Friday pickups with weekend options on request — call for rates and timing any hour of the day.",
    ],
    features: [
      "Next-day delivery to virtually every US market",
      "Door-to-door: pickup, linehaul, recovery, delivery",
      "Negotiated rates on major cargo carriers",
      "Heavy and oversized pieces accommodated",
      "Full tracking and proactive exception alerts",
    ],
    stats: [
      { k: "NEXT AM", v: "most markets" },
      { k: "1 CALL", v: "door to door" },
      { k: "$$", v: "negotiated rates" },
    ],
  },
  {
    slug: "same-day-air-nfo",
    name: "Same Day Air / NFO",
    tag: "AIR / NEXT FLIGHT OUT",
    image: IMAGES.same_day_air,
    blurb:
      "Next Flight Out via the airlines — the absolute fastest way to move smaller, lighter freight across the country.",
    description: [
      "For smaller, lighter freight there is no faster way to ship over long distance than NFO — Next Flight Out — via the airlines. Your shipment is booked on the very next available departure and met on arrival for immediate final delivery.",
      "Full door-to-door service handled with precision at every step: TSA-known shipper coordination, counter-to-counter tender, recovery and rush final mile. Up to 200 lbs per piece with dimensional limits — call for schedules and fast pricing around the clock.",
    ],
    features: [
      "Same-day delivery, coast to coast",
      "Next available flight, 24/7/365",
      "Up to 200 lbs per piece",
      "TSA-approved shipper coordination",
      "Counter-to-counter with rush final mile",
    ],
    stats: [
      { k: "SAME DAY", v: "nationwide" },
      { k: "200 LB", v: "per piece max" },
      { k: "24/7", v: "flight watch" },
    ],
  },
  {
    slug: "overnight-freight",
    name: "Overnight Freight",
    tag: "GROUND + AIR",
    image: IMAGES.truck,
    blurb:
      "On the road tonight or in the air tonight — overnight delivery, fully tracked, wherever it needs to be by morning.",
    description: [
      "Overnight freight is a promise, and we keep it. Shorter distances roll tonight in a dedicated van or truck; longer distances fly as overnight air cargo. Either way, our nationwide network delivers by morning — on time and fully tracked.",
      "One call covers the whole move. We choose the fastest mode that hits your deadline and your budget, then stay on it until the proof of delivery is in your inbox.",
    ],
    features: [
      "Ground or air — whichever wins your deadline",
      "Delivery by morning, most US lanes",
      "Fully tracked, end to end",
      "Evening pickups, morning deliveries",
      "Single point of contact throughout",
    ],
    stats: [
      { k: "10 PM", v: "typical cutoff" },
      { k: "8 AM", v: "earliest delivery" },
      { k: "100%", v: "tracked" },
    ],
  },
  {
    slug: "ltl-freight",
    name: "LTL Freight",
    tag: "ECONOMY / LINEHAUL",
    image: IMAGES.warehouse,
    blurb:
      "For less urgent palletized freight — economy linehaul options that protect your budget without losing oversight.",
    description: [
      "Not every shipment is an emergency. When timing matters but budget matters more, Way2Go accesses a range of linehaul providers for economy LTL shipping on palletized freight, Monday through Friday.",
      "We'll give you honest delivery estimates up front — LTL carries limited tracking, so we recommend freight insurance and set expectations in plain facts, not smooth talk. Call for pricing and timing today.",
    ],
    features: [
      "Economy rates on palletized freight",
      "Multiple linehaul carriers compared",
      "Honest transit estimates up front",
      "Insurance options recommended and arranged",
      "Monday–Friday service",
    ],
    stats: [
      { k: "ECONOMY", v: "linehaul rates" },
      { k: "MON–FRI", v: "service days" },
      { k: "1 CALL", v: "carrier compare" },
    ],
  },
  {
    slug: "specialized-freight",
    name: "Specialized Freight",
    tag: "WHITE-GLOVE / HIGH-VALUE",
    image: IMAGES.serverroom,
    blurb:
      "White-glove logistics for high-value technology infrastructure, medical devices, and sensitive electronics — climate-controlled, air-ride, tracked door to door.",
    description: [
      "Our specialized B2B nationwide transport solutions provide white-glove logistics engineered specifically for high-value technology infrastructure, medical devices, and sensitive electronic equipment.",
      "We understand that moving mission-critical assets requires more than standard freight handling, which is why our service utilizes climate-controlled, air-ride suspension vehicles equipped with advanced security tracking to ensure complete environmental stability and real-time visibility from pickup to drop-off.",
      "Our highly trained transport teams manage the entire chain of custody, utilizing specialized equipment like heavy-duty liftgates, stair-climbers, and custom pallet stabilization to seamlessly navigate complex corporate environments and facility loading docks.",
      "## White Glove Delivery:",
      "By combining strict risk-mitigation protocols with customized final-mile inside delivery and unboxing, we guarantee your sophisticated technological assets arrive in pristine condition, fully protecting your capital investments and eliminating operational downtime across your nationwide enterprise network.",
      "If you are ready to move mission-critical freight with zero compromise, call (800) 654-9403 or request your quote below — a specialist answers around the clock.",
    ],
    features: [
      "Climate-controlled, air-ride suspension vehicles",
      "Advanced security tracking with real-time visibility",
      "Full chain of custody managed by trained transport teams",
      "Liftgates, stair-climbers and custom pallet stabilization",
      "Final-mile inside delivery, unboxing and debris removal",
    ],
    stats: [
      { k: "100%", v: "chain of custody" },
      { k: "AIR-RIDE", v: "climate controlled" },
      { k: "24/7", v: "security tracking" },
    ],
  },
];

export const pricing = [
  { label: "SPRINTER VAN / 600 MI", value: "from $1,240" },
  { label: "SAME DAY AIR / NATIONWIDE", value: "from $935" },
  { label: "STRAIGHT TRUCK / 1,000 MI", value: "from $3,835" },
  { label: "NEXT DAY AIR / 500 LB PALLET", value: "from $2,630" },
  { label: "CROSSTOWN SPRINTER", value: "from $615" },
];

export const testimonials = [
  {
    quote:
      "If you have critical freight that requires immediate delivery, impeccable tracking, and exceptional customer service, I highly recommend Way2Go. Their professionalism and dedication made all the difference for our project's success.",
    author: "Alyson R.",
    role: "Manufacturing, Texas",
  },
  {
    quote:
      "Continuous contact and the driver was simply amazing. Critical customer SAT issue for us and Way2Go knocked it out of the park. They will get any and all freight I have moving forward.",
    author: "Jeanette",
    role: "Technology, Illinois",
  },
  {
    quote:
      "We were under immense pressure to deliver within 48 hours. Way2Go got the part to us in under 24. It literally saved the day — friendly service and zero drama.",
    author: "Bret P.",
    role: "Industrial Systems, Ohio",
  },
  {
    quote:
      "Great, constant communication. They mean what they say and back it up with action. When I expedite something, it's definitely Way2Go.",
    author: "Matthew K.",
    role: "Distribution, Pennsylvania",
  },
];
